/**
 * Opciones visibles del menú Compartir ticket / cierre / movimiento.
 * Un solo lugar: cambiar aquí aplica en ShareReceiptActions y ShareCierreActions.
 */

/** Oculta PNG/WhatsApp en UI. Código conservado; `true` reactiva sin reimplementar. */
export const SHOW_IMAGE_SHARE_OPTIONS = false;

export const PDF_SHARE_SECTION_LABEL = "Como PDF / Email · recomendado";

export const PDF_SHARE_ROW_DESCRIPTION =
  "WhatsApp u otra app — calidad completa";
